(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/snow-animation/assets/snow-animation.js') >= 0) return;  svs.modules.push('/components/tb-ui/snow-animation/assets/snow-animation.js');

'use strict';

const {
  useEffect,
  useRef,
  useState
} = React;
const SnowAnimation = _ref => {
  let {
    isFixed = false,
    snowflakeCount = 80,
    duration = 10,
    zIndex = 0,
    delay = 1000
  } = _ref;
  const canvasRef = useRef(null);
  const [opacity, setOpacity] = useState(0);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    const ctx = canvas.getContext('2d');
    let animationId;
    const snowflakes = [];
    const mainWind = {
      current: 0,
      target: 0
    };
    const random = {
      nextFloat: () => Math.random(),
      nextInt: (min, max) => Math.floor(Math.random() * (max - min) + min)
    };
    const updateCanvasSize = () => {
      canvas.width = window.innerWidth;
      const mainContentElement = document.getElementById('main-content');
      const targetHeight = mainContentElement && !isFixed ? mainContentElement.offsetHeight : window.innerHeight;
      canvas.height = targetHeight;
      snowflakes.forEach(flake => {
        if (flake.x > canvas.width + canvas.width) {
          flake.x = random.nextFloat() * canvas.width + canvas.width;
        }
        if (flake.y > canvas.height + 50) {
          flake.y = random.nextInt(0, canvas.height);
        }
      });
    };

    setTimeout(() => {
      updateCanvasSize();

      const referenceHeight = 1140;
      const scaledSnowflakeCount = Math.round(snowflakeCount * (canvas.height / referenceHeight));
      const actualSnowflakeCount = Math.max(snowflakeCount, scaledSnowflakeCount);
      for (let i = 0; i < actualSnowflakeCount; i++) {
        const depthFactor = random.nextFloat(); 
        const baseSize = depthFactor * 2 + 1; 
        const opacity = depthFactor * 0.5 + 0.4; 

        const snowflake = {
          x: random.nextFloat() * canvas.width + canvas.width,
          y: random.nextInt(0, canvas.height),
          velocityX: 0,
          depthFactor,
          windResistance: random.nextFloat(),
          baseSize,
          size: baseSize,
          opacity,
          baseOpacity: opacity,
          scale: 1 + random.nextFloat() * 0.5,
          canScale: random.nextFloat() < 0.20,
          scaleDirection: random.nextFloat() < 0.5 ? 1 : -1,
          currentWindScale: 1,
          targetWindScale: 1,
          blur: random.nextFloat() * 2,
          color: depthFactor > 0.7 ? '#ffffff' : '#ddd'
        };
        snowflakes.push(snowflake);
      }
      animationId = requestAnimationFrame(tick);
      setOpacity(1); 
    }, delay);
    const updateWind = () => {
      if (random.nextFloat() < 0.015) {
        mainWind.target = (0.5 - random.nextFloat()) * canvas.width / 15;
      }
      const diff = mainWind.target - mainWind.current;
      if (Math.abs(diff) > 0.1) {
        mainWind.current += diff / 100; 
      }
    };

    const spriteCache = new Map();
    const createBlurredSprite = (size, blur, color) => {
      const roundedSize = Math.max(0.1, Math.round(size * 2) / 2);
      const roundedBlur = Math.round(blur * 4) / 4;
      const key = "".concat(roundedSize, "-").concat(roundedBlur, "-").concat(color);
      if (spriteCache.has(key)) {
        return spriteCache.get(key);
      }
      if (spriteCache.size > 50) {
        return null; 
      }
      const spriteCanvas = document.createElement('canvas');
      const spriteSize = (roundedSize + roundedBlur) * 4;
      spriteCanvas.width = spriteSize;
      spriteCanvas.height = spriteSize;
      const spriteCtx = spriteCanvas.getContext('2d');
      if (roundedBlur > 0) {
        spriteCtx.filter = "blur(".concat(roundedBlur, "px)");
      }
      spriteCtx.fillStyle = color;
      spriteCtx.beginPath();
      spriteCtx.arc(spriteSize / 2, spriteSize / 2, roundedSize, 0, Math.PI * 2);
      spriteCtx.fill();
      spriteCache.set(key, {
        canvas: spriteCanvas,
        size: spriteSize
      });
      return spriteCache.get(key);
    };
    const drawSnowflake = flake => {
      const sprite = createBlurredSprite(flake.size, flake.blur, flake.color);
      ctx.globalAlpha = flake.opacity;
      if (sprite && sprite.canvas) {
        ctx.drawImage(sprite.canvas, flake.x % canvas.width - sprite.size / 2, flake.y - sprite.size / 2);
      } else {
        ctx.fillStyle = flake.color;
        ctx.beginPath();
        ctx.arc(flake.x % canvas.width, flake.y, flake.size, 0, Math.PI * 2);
        ctx.fill();
      }
    };
    const tick = () => {
      if (document.hidden) {
        animationId = requestAnimationFrame(tick);
        return;
      }

      if (canvas.width <= 0 || canvas.height <= 0) {
        animationId = requestAnimationFrame(tick);
        return;
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalAlpha = 1;
      updateWind();
      const viewportHeight = window.innerHeight;
      const speedMultiplier = duration > 0 ? 10 / duration : 1;
      const baseSpeedFactor = viewportHeight / 600;
      const depthSpeedFactor = viewportHeight / 400;
      snowflakes.forEach(flake => {
        const moveY = baseSpeedFactor * speedMultiplier + flake.depthFactor * depthSpeedFactor * speedMultiplier;
        const moveX = mainWind.current * flake.depthFactor * flake.windResistance * 0.8;

        flake.velocityX += (random.nextFloat() - 0.5) * 0.4;
        flake.velocityX *= 0.92;
        flake.x += moveX + flake.velocityX;
        flake.y += moveY;
        if (flake.y > canvas.height + 50) {
          flake.y = random.nextInt(-100, -50);
          flake.x = random.nextFloat() * canvas.width + canvas.width;
          flake.velocityX = 0;
          flake.currentWindScale = 1;
          flake.targetWindScale = 1;
        }

        if (flake.canScale) {
          const windStrength = Math.abs(mainWind.current) / 50;
          if (flake.scaleDirection > 0) {
            flake.targetWindScale = 1 + windStrength * 2.8; 
          } else {
            flake.targetWindScale = 1 - windStrength * 0.8; 
          }
        } else {
          flake.targetWindScale = 1;
        }

        const scaleDiff = flake.targetWindScale - flake.currentWindScale;
        flake.currentWindScale += scaleDiff * 0.1;
        flake.opacity = flake.baseOpacity;
        flake.size = Math.max(0.1, flake.baseSize * flake.scale * flake.currentWindScale);
        drawSnowflake(flake);
      });
      animationId = requestAnimationFrame(tick);
    };
    const handleResize = () => {
      updateCanvasSize();
    };
    window.addEventListener('resize', handleResize);
    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      window.removeEventListener('resize', handleResize);
    };
  }, [duration, isFixed, snowflakeCount, delay]);
  return React.createElement("canvas", {
    ref: canvasRef,
    style: {
      position: isFixed ? 'fixed' : 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      pointerEvents: 'none',
      zIndex,
      opacity,
      transition: 'opacity 1.5s ease-in-out'
    }
  });
};
svs.tb_ui.snow_animation.SnowAnimation = SnowAnimation;

 })(window);